import template from './resetApiKey.template.html';

/* @ngInject */

export default (
  $q,
  $scope,
  $state,
  $rootScope,
  $mdDialog,
  clipboard,
  webpage,
  uiService,
  authenticationService,
  changesService,
  navigationService,
  organizationService,
  OrganizationWebHooks
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    webHooks: [
      { title: 'Contact created', prop: 'contactCreated' },
      { title: 'Contact updated', prop: 'contactUpdated' },
      { title: 'Deal created', prop: 'dealCreated' },
      { title: 'Deal updated', prop: 'dealUpdated' },
      { title: 'Deal changes due date', prop: 'dealChangesDueDate' },
      { title: 'Deal changes stage', prop: 'dealChangesStage' },
      { title: 'Deal changes workflow', prop: 'dealChangesWorkflow' },
      { title: 'Deal changes status', prop: 'dealChangesStatus' },
      { title: `Deal has changes in it's attached files`, prop: 'dealChangesAttachments' },
      {
        title: `Deal has changes in it's required documents`,
        prop: 'dealChangesRequiredDocuments'
      },
      { title: 'Deal changes owner', prop: 'dealChangesOwner' },
      { title: 'Note created', prop: 'noteCreated' },
      { title: 'Note updated', prop: 'noteUpdated' }
    ],
    isClipboardSupported: clipboard.supported,
    isKeyVisible: false,
    isReady: false
  };

  /*
   * Controller Public Functions: Board
   * --------------------------------------------------------------------------------
   */
  $scope.resetKey = ($event) => {
    const resetApiKeyController = () => ({
      organizationName: '',
      isOrganizationNameEqual: (organizationName) =>
        organizationName.toLowerCase() ===
        $rootScope.CurrentOrganization.organization.name.toLowerCase(),
      confirm: () => $mdDialog.hide(),
      cancel: () => $mdDialog.cancel()
    });

    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          organizationName: $rootScope.CurrentOrganization.organization.name
        },
        template,
        controllerAs: '$ctrl',
        controller: resetApiKeyController
      })
      .then(() => {
        organizationService.resetApiKey().then(() => {
          uiService.toast({
            text: {
              p1: 'Resetting API key',
              p2: 'is in progress',
              p3: 'please wait'
            },
            progress: true,
            delay: 2500
          });
          navigationService
            .organizationChange({ idOrganization: $rootScope.CurrentOrganization.id })
            .then(() => {
              $state.reload();
            });
        });
      });
  };
  $scope.copyKey = () => {
    clipboard.copyText($rootScope.CurrentOrganization.apiKeyDigest);
    uiService.toast({
      text: {
        p1: 'API',
        p2: 'key',
        p3: 'copied to clipboard'
      }
    });
  };
  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      webHooks: $rootScope.CurrentOrganization.webHooks
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };
  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  /*
   * Run Controller
   * --------------------------------------------------------------------------------
   */
  $scope.isHelpDesk = () =>
    String($rootScope.CurrentAccount.getEmail()).trim() === 'helpdesk@salestrekker.com';

  const init = () => {
    webpage.pageTitle('Loading, please wait');
    if ($scope.isHelpDesk()) {
      organizationService
        .readOrganization({ id: $rootScope.CurrentOrganization.id })
        .then((data) => {
          // Overwrite $rootScope values in case they've reverted to values within Token
          $rootScope.CurrentOrganization.webHooks = OrganizationWebHooks.build(data.webHooks);
          $scope.Model.webHooks.available = Object.keys(OrganizationWebHooks.blank());
        })
        .then(() => {
          // Declare Model as Ready and start rendering the page
          webpage.pageTitle('Integrations : API');
          $scope.Model.isReady = true;
        });
    } else {
      $state.transitionTo('settings.my-account');
    }
  };
  init();
};
